import React from 'react';
import styled from '@benzinga/themetron';

import { Block as BlockInterface } from '@benzinga/content-manager';
import { Block } from './Block';
import { ErrorBoundary } from '@benzinga/core-ui';

export interface BlocksProps {
  blocks: BlockInterface[];
  className?: string;
  type?: 'default' | 'sidebar';
}

export const Blocks: React.FC<BlocksProps> = ({ blocks, className, type }) => {
  if (!Array.isArray(blocks)) {
    return null;
  }
  return (
    <BlocksWrapper className={className}>
      {blocks?.map((block: BlockInterface, i: number) => {
        return (
          <ErrorBoundary key={`block-${block?.blockName}-${i}`} name={`${block?.blockName}`}>
            <Block block={block} type={type} />
          </ErrorBoundary>
        );
      })}
    </BlocksWrapper>
  );
};

export const BlocksWrapper = styled.div`
  .right {
    float: right;
    margin-left: 0.5rem;
  }
  .left {
    float: left;
    margin-right: 0.5rem;
  }
  .center {
    text-align: center;
    margin: auto;
    > figure,
    > img,
    > div {
      margin: auto;
    }
  }
  h1,
  h2 {
    &.core-block {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
  }
  h2 {
    &.core-block {
      color: ${({ theme }) => theme.colors.foregroundInactive};
    }
  }
  h1 {
    &.core-block {
      font-size: ${({ theme }) => theme.fontSize['4xl']};
    }
  }
  h2 {
    &.core-block {
      font-size: ${({ theme }) => theme.fontSize['3xl']};
    }
  }
  h3 {
    &.core-block {
      font-size: ${({ theme }) => theme.fontSize['2xl']};
      margin: 1rem 0px 0.5rem 0px;
    }
  }
  h4 {
    &.core-block {
      font-size: ${({ theme }) => theme.fontSize['1xl']};
      margin: 1rem 0px 0.5rem 0px;
    }
  }
  ul {
    &.core-block {
      list-style: disc;
      margin-left: 2rem;
      margin-bottom: 2rem;
      ul,
      ol {
        margin-bottom: 0;
      }
    }
  }
  ol {
    &.core-block {
      list-style: decimal;
      margin-left: 2rem;
      margin-bottom: 2rem;
      li {
        margin-bottom: 0.2rem;
      }
      ul,
      ol {
        margin-bottom: 0;
      }
    }
  }
  .wp-block-spacer {
    clear: both;
  }
  p {
    &.core-block {
      font-size: 1.1rem;
    }
  }
  .core-block {
    a {
      color: #2ca2d1;
    }
  }
  .alignright {
    float: right;
    margin-left: 18px;
  }
  .wp-block-table {
    overflow-x: auto;
  }
  table.core-block {
    margin: 1rem 0;
    width: 100%;
    table-layout: fixed;

    tr {
      /* &:first-child {
        border-top: 1px solid #d6d6d6;
      } */
      &:nth-child(odd) {
        background: #f9f9f9;
        /* background: #f1f1f1; */
      }
    }
    td {
      /* border-right: 1px solid #d6d6d6; */
      border-bottom: 1px solid #d6d6d6;
      padding: 4px 8px;
      /* &:first-child {
        border-left: 1px solid #d6d6d6;
      } */
    }
  }
  .wp-block-quote {
    padding: 0 1em;
    margin: 0px 0px 2rem;
    line-height: 1.6;
    color: #2d2d2d;
    border-left: 2px solid ${({ theme }) => theme.colorPalette.blue800};
    font-style: italic;
  }
  .bz-campaign {
    hr {
      background: #5294c1;
      border: 0;
      height: 1px;
      margin-bottom: 26px;
      padding: 0;
    }
  }
`;
